import React, { useEffect, useState } from 'react';
import API from '../api';
import { IcPlus, IcTrash, IcVideo, IcX, IcCopy, IcDownload, IcTerminal, IcRefresh } from './Icons';

const SCHOOL_ID = 1;
const emptyForm = { label: '', rtsp_url: '', event_type: 'entry', skip_frames: 15 };

export default function CameraAgents() {
  const [agents, setAgents]       = useState([]);
  const [showForm, setShowForm]   = useState(false);
  const [form, setForm]           = useState(emptyForm);
  const [loading, setLoading]     = useState(false);
  const [msg, setMsg]             = useState('');
  const [cmdAgent, setCmdAgent]   = useState(null); // agent dont on affiche la commande

  const load = () => API.get(`/agents/school/${SCHOOL_ID}`).then(r => setAgents(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const submit = async () => {
    if (!form.label || !form.rtsp_url) return setMsg('Label et URL RTSP requis');
    setLoading(true); setMsg('');
    try {
      await API.post('/agents', { ...form, school_id: SCHOOL_ID, skip_frames: Number(form.skip_frames) });
      setForm(emptyForm); setShowForm(false); load();
    } catch (e) { setMsg(e.response?.data?.detail || 'Erreur'); }
    setLoading(false);
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer cet agent ?')) return;
    await API.delete(`/agents/${id}`); load();
  };

  const copyCmd = (a) => {
    const cmd = `python3 agent.py \\\n  --source "${a.rtsp_url_raw}" \\\n  --school-id ${SCHOOL_ID} \\\n  --event-type ${a.event_type} \\\n  --api-url https://chefdeclasse.com \\\n  --agent-id ${a.id} \\\n  --headless \\\n  --skip ${a.skip_frames}`;
    navigator.clipboard.writeText(cmd).then(() => {}).catch(() => {});
    setCmdAgent(a);
  };

  const downloadScript = (id) => {
    window.open(`https://chefdeclasse.com/api/agents/${id}/install.sh`, '_blank');
  };

  const F = ({ label, k, type = 'text', options }) => (
    <div>
      <label className="label">{label}</label>
      {options
        ? <select className="input" value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))}>
            {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        : <input className="input" type={type} value={form[k]}
            onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} />
      }
    </div>
  );

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <h1 className="page-title">Agents caméra IP</h1>
          <p className="page-subtitle">Caméras RTSP connectées au système de reconnaissance</p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          <IcPlus size={15} strokeWidth={2.5} /> Ajouter une caméra
        </button>
      </div>

      {/* Formulaire d'ajout */}
      {showForm && (
        <div className="card" style={{ padding: 24, marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <div style={{ fontWeight: 600, fontSize: 14 }}>Nouvelle caméra</div>
            <button className="btn btn-ghost btn-icon" onClick={() => setShowForm(false)}><IcX size={15} /></button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <F label="Nom de la caméra" k="label" />
            <F label="Type d'événement" k="event_type" options={[{ v: 'entry', l: 'Entrée' }, { v: 'exit', l: 'Sortie' }]} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label className="label">URL RTSP</label>
            <input className="input" type="text" value={form.rtsp_url}
              placeholder="rtsp://admin:motdepasse@192.168.1.64:554/stream"
              onChange={e => setForm(f => ({ ...f, rtsp_url: e.target.value }))} />
            <div style={{ fontSize: 11, color: 'var(--slate-400)', marginTop: 5 }}>
              Format selon la marque : Hikvision → /Streaming/Channels/101 · Dahua → /cam/realmonitor?channel=1 · TP-Link → /stream1
            </div>
          </div>
          <div style={{ marginBottom: 14, maxWidth: 200 }}>
            <label className="label">Analyser 1 frame sur</label>
            <input className="input" type="number" min={5} max={60} value={form.skip_frames}
              onChange={e => setForm(f => ({ ...f, skip_frames: e.target.value }))} />
            <div style={{ fontSize: 11, color: 'var(--slate-400)', marginTop: 5 }}>15 = analyse toutes les ~2s</div>
          </div>
          {msg && <div style={{ padding: '8px 12px', background: 'var(--red-l)', color: 'var(--red)', borderRadius: 7, fontSize: 12, marginBottom: 12 }}>{msg}</div>}
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" onClick={submit} disabled={loading}>{loading ? 'Création...' : 'Créer l\'agent'}</button>
            <button className="btn btn-ghost" onClick={() => setShowForm(false)}>Annuler</button>
          </div>
        </div>
      )}

      {/* Modal commande */}
      {cmdAgent && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div className="card" style={{ padding: 24, maxWidth: 620, width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 15 }}>Commande — {cmdAgent.label}</div>
              <button className="btn btn-ghost btn-icon" onClick={() => setCmdAgent(null)}><IcX size={15} /></button>
            </div>
            <p style={{ fontSize: 13, color: 'var(--slate-500)', marginBottom: 14 }}>
              Exécute cette commande sur le Raspberry Pi ou PC qui est sur le même réseau que la caméra.
            </p>
            <pre style={{ background: 'var(--slate-900, #0F172A)', color: '#E2E8F0', padding: '14px 16px', borderRadius: 10, fontSize: 12, overflowX: 'auto', lineHeight: 1.7 }}>{`python3 agent.py \\
  --source "${cmdAgent.rtsp_url_raw}" \\
  --school-id ${SCHOOL_ID} \\
  --event-type ${cmdAgent.event_type} \\
  --api-url https://chefdeclasse.com \\
  --agent-id ${cmdAgent.id} \\
  --headless \\
  --skip ${cmdAgent.skip_frames}`}</pre>
            <div style={{ marginTop: 16, padding: '12px 14px', background: 'var(--indigo-l, #EEF2FF)', borderRadius: 9, fontSize: 12, color: 'var(--indigo, #6366F1)', lineHeight: 1.6 }}>
              <strong>Prérequis :</strong> Python 3 + pip3 install opencv-python-headless requests
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
              <button className="btn btn-primary" onClick={() => { navigator.clipboard.writeText(`python3 agent.py --source "${cmdAgent.rtsp_url_raw}" --school-id ${SCHOOL_ID} --event-type ${cmdAgent.event_type} --api-url https://chefdeclasse.com --agent-id ${cmdAgent.id} --headless --skip ${cmdAgent.skip_frames}`); }}>
                <IcCopy size={14} /> Copier
              </button>
              <button className="btn btn-ghost" onClick={() => downloadScript(cmdAgent.id)}>
                <IcDownload size={14} /> Script d'installation complet
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Liste des agents */}
      <div className="card" style={{ overflow: 'hidden' }}>
        {agents.length === 0 ? (
          <div className="empty">
            <IcVideo size={40} stroke="var(--slate-300)" />
            <p style={{ marginTop: 12 }}>Aucune caméra configurée</p>
            <p style={{ fontSize: 12, color: 'var(--slate-400)', marginTop: 4 }}>Ajoutez une caméra IP RTSP pour démarrer la reconnaissance automatique</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Statut</th>
                <th>Caméra</th>
                <th>URL RTSP</th>
                <th>Type</th>
                <th>Fréquence</th>
                <th>Dernier ping</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {agents.map(a => (
                <tr key={a.id}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                      <div style={{ width: 10, height: 10, borderRadius: '50%', background: a.online ? '#10B981' : '#CBD5E1', flexShrink: 0 }} />
                      <span style={{ fontSize: 12, fontWeight: 600, color: a.online ? '#065F46' : 'var(--slate-400)' }}>
                        {a.online ? 'En ligne' : 'Hors ligne'}
                      </span>
                    </div>
                  </td>
                  <td style={{ fontWeight: 600, fontSize: 13 }}>{a.label}</td>
                  <td>
                    <code style={{ fontSize: 11, background: 'var(--slate-100)', padding: '2px 6px', borderRadius: 5, color: 'var(--slate-600)' }}>
                      {a.rtsp_url}
                    </code>
                  </td>
                  <td>
                    <span className={`badge ${a.event_type === 'entry' ? 'badge-emerald' : 'badge-amber'}`}>
                      {a.event_type === 'entry' ? 'Entrée' : 'Sortie'}
                    </span>
                  </td>
                  <td style={{ color: 'var(--slate-500)', fontSize: 12 }}>1 / {a.skip_frames} frames</td>
                  <td style={{ fontSize: 11, color: 'var(--slate-400)' }}>
                    {a.last_ping ? new Date(a.last_ping).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '—'}
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-ghost btn-sm" title="Voir la commande" onClick={() => setCmdAgent(a)}>
                        <IcTerminal size={13} />
                      </button>
                      <button className="btn btn-ghost btn-sm" title="Télécharger le script" onClick={() => downloadScript(a.id)}>
                        <IcDownload size={13} />
                      </button>
                      <button className="btn btn-danger btn-sm btn-icon" onClick={() => del(a.id)}>
                        <IcTrash size={13} strokeWidth={2} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Guide rapide */}
      <div className="card" style={{ padding: 24, marginTop: 20 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 16 }}>Guide de démarrage rapide</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          {[
            { n: '1', title: 'Acheter la caméra', body: 'N\'importe quelle caméra IP avec RTSP : Hikvision, Dahua, TP-Link, Reolink. Prix : 15 000 – 50 000 FCFA.' },
            { n: '2', title: 'Préparer le Raspberry Pi', body: 'Raspberry Pi 3 ou 4 (30 000 FCFA). Brancher sur le réseau de l\'école avec la caméra.' },
            { n: '3', title: 'Lancer le script', body: 'Télécharger le script d\'installation généré et l\'exécuter avec : sudo bash install-agent-X.sh' },
          ].map(({ n, title, body }) => (
            <div key={n} style={{ display: 'flex', gap: 12 }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--indigo-l, #EEF2FF)', color: 'var(--indigo, #6366F1)', fontWeight: 800, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{n}</div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>{title}</div>
                <div style={{ fontSize: 12, color: 'var(--slate-500)', lineHeight: 1.6 }}>{body}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
